(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maverick-hg2-reboot"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('maverick-hg2')) return;

  class MaverickHG2 extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      queueMicrotask(() => { if (this.isConnected) this.initialize(); });
    }

    initialize() {
      const configNode = this.querySelector('[data-mhg-config]');
      if (!configNode) return;
      try { this.config = JSON.parse(configNode.textContent); }
      catch (error) { console.error('Maverick HG2: product configuration could not be read.', error); return; }

      this.abort = new AbortController();
      this.options = [...this.config.initialOptions];
      if (this.config.sizeIndex >= 0 && !this.config.explicitVariantId) this.options[this.config.sizeIndex] = null;
      this.form = this.querySelector('.mhg-form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.addButton = this.querySelector('[data-main-add]');
      this.status = this.querySelector('[data-form-status]');
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-media-slide]')];
      this.busy = false;
      this.mainPassed = false;
      this.finalVisible = false;

      this.listen(this, 'change', (event) => this.onChange(event));
      this.listen(this, 'click', (event) => this.onClick(event));
      this.listen(this.form, 'submit', (event) => this.addToCart(event));
      this.listen(this.track, 'scroll', () => {
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame = requestAnimationFrame(() => this.updateGallery());
      }, { passive: true });
      this.listen(this.track, 'keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        if (event.target.closest('video, iframe, input, select')) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.showSlide(Math.max(0, Math.min(this.slides.length - 1, this.slideIndex() + direction)));
      });

      this.querySelectorAll('dialog').forEach((dialog) => {
        this.listen(dialog, 'click', (event) => { if (event.target === dialog) dialog.close(); });
        this.listen(dialog, 'close', () => {
          document.documentElement.classList.remove('mhg-modal-lock');
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
          this.updateSticky();
        });
      });

      if ('IntersectionObserver' in window) {
        this.buyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.addButton) this.mainPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            else this.finalVisible = entry.isIntersecting;
          });
          this.updateSticky();
        });
        this.buyObserver.observe(this.addButton);
        this.buyObserver.observe(this.querySelector('.mhg-final'));
      }

      this.overlayObserver = new MutationObserver(() => this.updateSticky());
      this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.querySelectorAll('cart-drawer, cart-notification').forEach((element) => {
        this.overlayObserver.observe(element, { attributes: true, attributeFilter: ['class'] });
      });

      this.classList.add('is-ready');
      this.updateVariant(false);
      this.updateGallery();
      if (this.config.explicitVariantId) this.showVariantImage();
    }

    listen(target, type, callback, options = {}) {
      target?.addEventListener(type, callback, { ...options, signal: this.abort.signal });
    }

    disconnectedCallback() {
      const hadOpenDialog = !!this.querySelector('dialog[open]');
      this.abort?.abort();
      this.buyObserver?.disconnect();
      this.overlayObserver?.disconnect();
      cancelAnimationFrame(this.galleryFrame);
      this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      if (hadOpenDialog) document.documentElement.classList.remove('mhg-modal-lock');
      this._started = false;
    }

    onChange(event) {
      const input = event.target.closest('[data-option-index]');
      if (!input || !input.checked || this.busy) return;
      this.options[Number(input.dataset.optionIndex)] = input.value;
      this.clearStatus();
      this.updateVariant(true);
      this.showVariantImage();
    }

    matchingVariants(options, ignoredIndex = -1) {
      return this.config.variants.filter((variant) => options.every((value, index) => index === ignoredIndex || value == null || variant.options[index] === value));
    }

    selectedVariant() {
      if (this.options.some((value) => value == null)) return null;
      return this.matchingVariants(this.options)[0] || null;
    }

    cheapest(variants) {
      const available = variants.filter((variant) => variant.available);
      return [...(available.length ? available : variants)].sort((a, b) => a.price - b.price)[0] || null;
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.config.currency }).format(cents / 100);
      } catch (_) { return `${(cents / 100).toFixed(2)} ${this.config.currency}`; }
    }

    coverageLabel(value) {
      const input = [...this.querySelectorAll('[data-has-sides]')].find((radio) => radio.value === value);
      return input ? (input.dataset.hasSides === 'true' ? this.config.sideLabel : this.config.frontLabel) : value;
    }

    updateVariant(updateUrl) {
      this.variant = this.selectedVariant();
      const displayVariant = this.variant || this.cheapest(this.matchingVariants(this.options));
      const needsSize = this.config.sizeIndex >= 0 && !this.options[this.config.sizeIndex];
      const complete = this.options.every((value) => value != null);
      const quantitySupported = !this.variant || (this.variant.min <= 1 && this.variant.increment <= 1 && (this.variant.max == null || this.variant.max >= 1));
      this.orderable = !!(this.variant?.available && quantitySupported);
      this.idInput.value = this.variant ? String(this.variant.id) : '';
      this.idInput.disabled = !this.orderable;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));

      this.querySelectorAll('[data-price], [data-sticky-price], [data-final-price]').forEach((node) => { node.textContent = displayVariant?.money || 'Unavailable'; });
      this.querySelector('[data-price-prefix]').textContent = complete ? '' : 'From';
      const compare = this.querySelector('[data-compare]');
      compare.hidden = !(displayVariant && displayVariant.compareAt > displayVariant.price);
      compare.textContent = compare.hidden ? '' : displayVariant.compareMoney;

      const availability = this.querySelector('[data-availability]');
      availability.textContent = complete && !this.variant?.available ? 'Unavailable' : this.config.availabilityText;
      availability.hidden = !availability.textContent;
      availability.classList.toggle('is-unavailable', complete && !this.variant?.available);

      const summaries = [];
      this.options.forEach((value, index) => {
        if (value != null) summaries.push(index === this.config.coverageIndex ? this.coverageLabel(value) : value);
      });
      const summary = summaries.join(' · ');
      let label = needsSize ? 'Choose your size' : !complete ? 'Choose your options' : !quantitySupported ? 'Contact us to order' : !this.variant?.available ? 'Unavailable' : 'Add to cart';
      this.querySelector('[data-add-label]').textContent = label;
      this.addButton.disabled = this.busy || (complete && !this.orderable);
      this.querySelectorAll('[data-secondary-buy]').forEach((button) => {
        button.textContent = this.busy ? 'Adding…' : label + ' →';
        button.disabled = this.busy;
      });
      this.querySelector('[data-selection]').textContent = needsSize ? 'Select your size. Front and back armor is included in both configurations.' : !complete ? 'Choose each option to continue.' : !quantitySupported ? 'Contact our team for this configuration’s quantity requirements.' : !this.variant?.available ? `${summary} is currently unavailable. Choose another configuration.` : summary;
      this.querySelector('[data-final-summary]').textContent = needsSize ? `${summary}. Choose your size to finish your configuration.` : summary;
      this.querySelector('[data-sticky-summary]').textContent = needsSize ? 'Choose your size' : summary;

      this.querySelectorAll('.mhg-size-choice input').forEach((input) => {
        const proposed = [...this.options];
        proposed[Number(input.dataset.optionIndex)] = input.value;
        input.disabled = !this.matchingVariants(proposed).some((variant) => variant.available);
        input.closest('label').classList.toggle('is-unavailable', input.disabled);
      });

      const coverageInputs = [...this.querySelectorAll('[data-has-sides]')];
      const baseInput = coverageInputs.find((input) => input.dataset.hasSides === 'false');
      let base = null;
      if (baseInput) { const proposed = [...this.options]; proposed[this.config.coverageIndex] = baseInput.value; base = this.cheapest(this.matchingVariants(proposed)); }
      coverageInputs.forEach((input) => {
        const proposed = [...this.options]; proposed[this.config.coverageIndex] = input.value;
        const candidates = this.matchingVariants(proposed);
        const cheapest = this.cheapest(candidates);
        const card = input.closest('label');
        card.querySelector('[data-coverage-price]').textContent = cheapest ? `${needsSize ? 'From ' : ''}${cheapest.money}` : 'Unavailable for this size';
        const upgrade = card.querySelector('[data-coverage-upgrade]');
        upgrade.textContent = input.dataset.hasSides === 'true' && base && cheapest && cheapest.price > base.price ? `${this.formatMoney(cheapest.price - base.price)} more than front/back` : '';
        card.classList.toggle('is-unavailable', !candidates.some((variant) => variant.available));
      });

      if (updateUrl && this.variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(this.variant.id));
        window.history.replaceState({ ...window.history.state }, '', url.href);
      }
      if (updateUrl) this.dispatchEvent(new CustomEvent('maverick:variant-change', { bubbles: true, detail: { productId: this.config.productId, variant: this.variant, options: [...this.options] } }));
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.matches('[data-open-fit]')) this.openDialog(this.querySelector('[data-fit-dialog]'), button);
      if (button.matches('[data-close-dialog]')) button.closest('dialog').close();
      if (button.matches('[data-secondary-buy]')) {
        if (this.orderable) this.form.requestSubmit(this.addButton);
        else this.focusConfiguration();
      }
      if (button.hasAttribute('data-thumb')) {
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === button.dataset.thumb);
        if (index >= 0) this.showSlide(index);
      }
      if (button.hasAttribute('data-zoom')) {
        const source = button.querySelector('img');
        const enlarged = this.querySelector('[data-zoom-image]');
        enlarged.src = source.src;
        enlarged.alt = source.alt;
        this.openDialog(this.querySelector('[data-zoom-dialog]'), button);
      }
      if (button.hasAttribute('data-fit-size')) {
        const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');
        const input = [...this.querySelectorAll('.mhg-size-choice input')].find((radio) => Number(radio.dataset.optionIndex) === this.config.sizeIndex && normalize(radio.value) === normalize(button.dataset.fitSize));
        if (input && !input.disabled && !this.busy) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          button.closest('dialog').close();
        } else {
          const message = input?.disabled ? 'That size is unavailable in the selected coverage. Choose another coverage or contact us.' : 'Select your size using the product’s size choices, or contact us for help.';
          this.setStatus(message, true);
          button.closest('dialog').close();
          this.focusConfiguration();
        }
      }
      if (button.hasAttribute('data-set-coverage')) {
        const sides = button.dataset.setCoverage === 'sides';
        const radio = [...this.querySelectorAll('[data-has-sides]')].find((input) => (input.dataset.hasSides === 'true') === sides);
        if (radio && !this.busy) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        this.focusConfiguration();
      }
    }

    focusConfiguration() {
      const index = this.config.sizeIndex >= 0 && !this.options[this.config.sizeIndex] ? this.config.sizeIndex : this.options.findIndex((value) => value == null);
      const group = this.querySelector(`[data-option-group="${index >= 0 ? index : this.config.sizeIndex}"]`) || this.form;
      group.scrollIntoView({ behavior: this.motion(), block: 'center' });
      const focus = group.querySelector('input:not(:disabled)') || this.addButton;
      focus?.focus({ preventScroll: true });
    }

    motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

    openDialog(dialog, trigger) {
      this.returnFocus = trigger;
      if (typeof dialog.showModal !== 'function') { if (dialog.matches('[data-fit-dialog]')) this.querySelector('.mhg-fit-section').scrollIntoView(); return; }
      dialog.showModal();
      document.documentElement.classList.add('mhg-modal-lock');
      this.updateSticky();
    }

    slideIndex() { return this.track?.clientWidth ? Math.round(this.track.scrollLeft / this.track.clientWidth) : 0; }

    showSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: this.motion() });
      this.slides.forEach((item) => { if (item !== slide) item.querySelectorAll('video').forEach((video) => video.pause()); });
    }

    updateGallery() {
      const index = Math.max(0, Math.min(this.slides.length - 1, this.slideIndex()));
      const id = this.slides[index]?.dataset.mediaId;
      this.querySelectorAll('[data-thumb]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.thumb === id)));
      const count = this.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${index + 1} / ${this.slides.length}`;
    }

    showVariantImage() {
      const id = this.variant?.mediaId;
      if (!id) return;
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(id));
      if (index >= 0) this.showSlide(index);
    }

    updateSticky() {
      const sticky = this.querySelector('[data-sticky]');
      if (!sticky) return;
      const overlay = this.querySelector('dialog[open]') || document.querySelector('cart-drawer.active, cart-notification.active') || document.body.classList.contains('overflow-hidden');
      sticky.hidden = !this.mainPassed || this.finalVisible || !!overlay;
    }

    setStatus(message, error = false) {
      this.status.textContent = message;
      this.status.hidden = false;
      this.status.classList.toggle('is-error', error);
    }

    clearStatus() {
      this.status.hidden = true;
      this.querySelector('[data-cart-fallback]').hidden = true;
    }

    setBusy(value) {
      this.busy = value;
      this.form.setAttribute('aria-busy', String(value));
      this.querySelectorAll('[data-option-index]').forEach((input) => { if (value) input.disabled = true; else input.disabled = false; });
      if (value) {
        this.addButton.disabled = true;
        this.querySelector('[data-add-label]').textContent = 'Adding…';
        this.querySelectorAll('[data-secondary-buy]').forEach((button) => { button.disabled = true; button.textContent = 'Adding…'; });
      } else this.updateVariant(false);
    }

    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      if (!this.orderable) { this.focusConfiguration(); return; }
      const variant = this.variant;
      this.clearStatus();
      this.setBusy(true);
      let added = false;
      let cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      let sections = [];
      try {
        const formData = new FormData(this.form);
        formData.set('id', String(variant.id));
        formData.set('quantity', '1');
        if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
          sections = cart.getSectionsToRender().slice(0, 5).map((section) => section.id);
          formData.set('sections', sections.join(','));
          formData.set('sections_url', window.location.pathname + window.location.search);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.addButton);
        } else cart = null;
        const response = await fetch(this.config.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData, credentials: 'same-origin' });
        const data = await response.json();
        if (!response.ok || data.status) {
          this.setStatus(data.description || data.message || 'This configuration could not be added. Please review your selection.', true);
          return;
        }
        added = true;
        this.setStatus('Added to your cart.');
        const detail = { productId: this.config.productId, variantId: variant.id, quantity: 1, value: variant.price / 100, currency: this.config.currency, cartData: data };
        this.dispatchEvent(new CustomEvent('maverick:cart-added', { bubbles: true, detail }));
        // Keep Dawn's cart subscribers informed. Ad pixels remain owned by installed integrations.
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'maverick-hg2', productVariantId: variant.id, cartData: data }); } catch (_) { /* Dawn versions differ. */ }

        const hasSections = cart && sections.length && sections.every((id) => typeof data.sections?.[id] === 'string');
        if (hasSections) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } catch (error) {
            console.warn('Maverick HG2: item added; showing the cart link because the drawer could not refresh.', error);
            this.querySelector('[data-cart-fallback]').hidden = false;
          }
        } else if (cart) {
          this.querySelector('[data-cart-fallback]').hidden = false;
        } else {
          window.location.assign(this.config.cartUrl);
        }
      } catch (error) {
        // Never retry a cart POST automatically: a lost response may still have added the item.
        this.setStatus(added ? 'Added to your cart. Use the cart link to continue.' : 'We could not confirm the cart response. Check your cart before trying again.', !added);
        this.querySelector('[data-cart-fallback]').hidden = false;
        console.warn('Maverick HG2 cart response:', error);
      } finally {
        if (this.isConnected) this.setBusy(false);
      }
    }
  }

  customElements.define('maverick-hg2', MaverickHG2);
})();


  } catch(e) { console.error(e); }
})();
})();
